const navLink = {
  displayField: 'title',
  name: 'Nav Link',
  description: '',
  fields: [
    {
      id: 'title',
      name: 'title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'cta',
      name: 'Link',
      type: 'Link',
      localized: false,
      required: true,
      validations: [ { linkContentType: [ 'link' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'linkList',
      name: 'Sub Links',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'link' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'lock',
      name: 'Lock',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      defaultValue: { 'en-US': false },
      disabled: false,
      omitted: false
    }
  ],
  sys: { id: 'navLink', version: 8, updatedAt: '2023-06-06T13:33:48.405Z' }
};
export default navLink;